module.exports = __webpack_public_path__ + "media/img/logo-8f6c12fd55af0a4f383437303f1ae3a6.svg";